import {isEmpty} from "lodash";
import {FeedbackPage, GradeSettings} from "migration/entities/Feedback";
import {MlString} from "migration/entities/base/mlString";
import {cmdSaveGradeTyTextsFeedbackPageReq} from "../../api/feedbackEditService";
import type {GradeType} from "./FormFeedbackMark";

const emptyBlock = (): GradeSettings => ({
    TYText: {
        TYTitle: {} as MlString,
        TYSubtitle: {} as MlString,
    },
    TYLink: [],
    reasons: [],
});

function ensureGradingBlock(feedbackPage: FeedbackPage, gradeType: GradeType): GradeSettings {
    switch (gradeType) {
        case "positiveGrading":
        case "negativeGrading":
            if (isEmpty(feedbackPage[gradeType])) {
                feedbackPage[gradeType] = emptyBlock();
            }
            return feedbackPage[gradeType];
        default:
            if (isEmpty(feedbackPage.specificGrading)) {
                feedbackPage.specificGrading = {};
            }
            if (isEmpty(feedbackPage.specificGrading[gradeType])) {
                feedbackPage.specificGrading[gradeType] = emptyBlock();
            }
            return feedbackPage.specificGrading[gradeType];
    }
}

/**
 * Builds the save payload for one grading block's thank-you texts.
 *
 * Both values are parameters rather than read from component state: the callers
 * are render-time closures, so a value produced asynchronously (a translation)
 * is invisible to them and would be silently replaced by the stale one.
 *
 * Returns null when either text is empty - a half-filled pair is not saved.
 */
export function buildTyTextsRequest(
    feedbackPage: FeedbackPage,
    gradeType: GradeType,
    title: MlString,
    subTitle: MlString,
): {request: cmdSaveGradeTyTextsFeedbackPageReq; updatedFeedback: FeedbackPage} | null {
    const updatedFeedback = {...feedbackPage};

    const block = ensureGradingBlock(updatedFeedback, gradeType);
    block.TYText.TYTitle = title;
    block.TYText.TYSubtitle = subTitle;

    if (isEmpty(block.TYText.TYTitle) || isEmpty(block.TYText.TYSubtitle)) {
        return null;
    }

    return {
        request: {
            feedbackPageId: feedbackPage?.id,
            TYTitle: block.TYText.TYTitle,
            TYSubtitle: block.TYText.TYSubtitle,
        },
        updatedFeedback,
    };
}
